import { useParams } from 'react-router-dom';
import BaseOrientationCheckout from './BaseOrientationCheckout';

const NursingOrientationCheckout = () => {
    const { uuid } = useParams<{ uuid: string }>();
    return (
        <BaseOrientationCheckout
            // eventUuid={uuid || ''} //------------------------------------------------------------------ Temporary put back after
            primaryColor="#8b0300" // Nursing red
            secondaryColor="#ffffff" // Nursing white
            gradientFrom="from-[#fff]"
            gradientTo="to-[#8b0300]"
            logoUrl="/branding/orientation/nursing.png"
            customDateText="September 6 - 13, 2026"
            customLinks={[
                // {
                //     alias: "Nursing Resources",
                //     url: "https://www.mcmaster.ca/nursing/resources"
                // },
                // {
                //     alias: "Program Guide",
                //     url: "https://www.mcmaster.ca/nursing/program-guide"
                // },
                // {
                //     alias: "Student Services",
                //     url: "https://www.mcmaster.ca/nursing/student-services"
                // }
            ]}
            customStyles={{
                headerBg: 'bg-[#8b0300]/10',
                cardBg: 'bg-white',
                buttonGradient: 'linear-gradient(to right, #8b0300, #ffffff)',
                buttonHoverGradient: 'linear-gradient(to right, #8b0300, #ffcccc)',
                tagBg: 'bg-[#8b0300] text-white' // for tags like date, time, location
            }}
            cropLogoToCircle={true}
            eventUuid='4b1110bf-c5fb-4aa7-92df-d61eac5a6d47' // ---------------------------------------------------------------------------- TEMPORARY
            hidePhoneNumber={true}
            hideTicketsAvailable={true}
        />
    );
};

export default NursingOrientationCheckout; 